import { styled } from "@mui/material";

const Badge = styled("div")(({ theme }) => ({
  width: "10px",
  height: "10px",
  backgroundColor: theme.palette.primary[400],
  borderRadius: "50%",
}));

const Empty = styled("div")(() => ({
  width: "10px",
  height: "10px",
  backgroundColor: "transparent",
}));

type Props = {
  isRead: boolean;
};

export const NotificationBadge = ({ isRead }: Props) => {
  return isRead ? <Empty /> : <Badge />;
};
